import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {t} from 'i18next';
import {ReactComponent as Fileicon} from '../../../assests/svg/file-icon.svg';
// Define the interface for the AurProgressBar component props
interface ProgressBarProps {
  children?: React.ReactNode;
  value: number;
  fileName: string;
  showIcon?: boolean;
}

const AurProgressBar: React.FC<ProgressBarProps> = ({
  value,
  fileName,
  children,
  showIcon = false,
}) => {
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <Box
      className="progress-bar-container-gradient-border "
      aria-describedby="uploadprocessingHint"
    >
      <span id="uploadprocessingHint" className="upload-processing-hint">
        {t('common.aurUploadBox.fileuploadinprogress')}
      </span>{' '}
      <div className="progress-bar-container-text">
        <Typography
          className="typo-text headline2_size processing-text"
          gutterBottom
        >
          {t('common.aurUploadBox.uploadProcessingText')}
        </Typography>
        <Typography className="typo-text body2_size filename-box" gutterBottom>
        {showIcon && <Fileicon />} {fileName}
        </Typography>
        <Typography className="typo-text display1_size percentage-box">
          {clampedValue}% {/* Displays the current progress percentage */}
        </Typography>
        <div className="test">
          <div
            className="progress-bar-container-withouttext"
            aria-label="polite"
          >
            {Array.from({length: 100}).map((_, index) => (
              <div
                key={index}
                className={
                  index >= clampedValue
                    ? 'progress-bar-vertical' // Class for bars representing remaining progress
                    : 'progress-bar-vertical-inprogress' // Class for bars representing completed progress
                }
              />
            ))}
          </div>
        </div>
      </div>
      <div className="aur-progress-bar-children-container">{children}</div>
    </Box>
  );
};

export default AurProgressBar;
